import { TimeOfDayPeriod } from "@greeter/date";
import { Card } from "@greeter/matter-v2";
import { IconChevronRight } from "@tabler/icons-react";
import { classNames } from "@greeter/util";

import css from "./TicketEventCard.module.scss";

export type TicketEventCardProps = {
  active?: boolean;
  title?: string;
  onClick?: () => void;
} & TicketEventCardDetailsProps;

export function TicketEventCard(props: TicketEventCardProps) {
  return (
    <Card variant="dark" onClick={props.onClick}>
      <Card.Content className={css.Content}>
        <div className={css.Left}>
          {props.active && <TicketEventCard.Status />}
          <TicketEventCard.Title>{props.title}</TicketEventCard.Title>
          <TicketEventCard.Details {...props} />
        </div>
        <div className={css.IconContainer}>
          <IconChevronRight />
        </div>
      </Card.Content>
    </Card>
  );
}

TicketEventCard.Title = function (props: React.PropsWithChildren) {
  return <h4 className={css.Title}>{props.children}</h4>;
};

type TicketEventCardDetailsProps = {
  date: Date;
  timePeriod: TimeOfDayPeriod;
};
TicketEventCard.Details = function (props: {
  date: Date;
  timePeriod: TimeOfDayPeriod;
}) {
  return (
    <span className={css.Details}>
      {props.date.getDate()}/
      {(props.date.getMonth() + 1).toString().padStart(2, "0")} |{" "}
      {props.timePeriod.from.toString()} - {props.timePeriod.to.toString()}
    </span>
  );
};

TicketEventCard.Status = function () {
  return (
    <span {...classNames(css.Status)}>
      <TicketEventCard.Dot /> <span className={css.StatusText}>AKTIV NU</span>
    </span>
  );
};

TicketEventCard.Dot = function () {
  return <span className={css.Dot} />;
};
